import TranscoderService from "@/services/TranscoderService";
import router from "@/router";
import _ from "lodash";

const defaultState = () => ({
  transcoders: [],
  transcoder: {},
  currentTranscoderId: "",
  transcoderLoaded: false,
  isLoading: false,
  isLoaded: false,
});

const state = defaultState();

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  GET_TRANSCODERS(state, transcoders) {
    state.transcoders = transcoders
    state.isLoaded = true;
    state.isLoading = false;
  },
  GET_TRANSCODER(state, transcoder) {
    state.transcoder = transcoder
    state.transcoderLoaded = true
  },
  SET_CURRENT_TRANSCODER(state, id) {
    state.currentTranscoderId = id
  },
};

const actions = {
  async getTranscoders({ commit, state }, forceRefresh = false) {
    // If already loaded and not forcing refresh, skip
    if (state.isLoaded && !forceRefresh) {
      return state.transcoders;
    }
    
    // If currently loading, wait for it
    if (state.isLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.isLoading) {
            clearInterval(checkLoading);
            resolve(state.transcoders);
          }
        }, 50);
      });
    }
    
    commit("SET_LOADING", true);
    try {
      const transcoders = await TranscoderService.getTranscoders()
      commit("GET_TRANSCODERS", transcoders)
      return transcoders;
    } catch (error) {
      commit("SET_LOADING", false);
      throw error;
    }
  },
  async getTranscoder({ commit }, id) {
    const transcoder = await TranscoderService.getTranscoder(id)
    commit("GET_TRANSCODER", transcoder)
  },
  // Show a transcoder from the already-loaded list while its detail request runs.
  seedTranscoder({ commit, state }, id) {
    const listed = state.transcoders.find((item) => item._id === id);
    if (!listed) return false;
    commit("GET_TRANSCODER", _.cloneDeep(listed));
    return true;
  },
  setCurrentTranscoder({ commit }, id) {
    commit("SET_CURRENT_TRANSCODER", id)
  },
};

const getters = {
  transcoders: (state) => state.transcoders,
  transcoder: (state) => state.transcoder,
  currentTranscoder: (state) => {
    if (state.currentTranscoderId === '') {
      return state.transcoders.find(
        (ts) =>
            ts._id === (router.currentRoute.params && router.currentRoute.params.transcoderId)
      );
    } else {
      return state.transcoders.find((ts) => ts._id === state.currentTranscoderId);
    }
  },
  transcoderLoaded: (state) => state.transcoderLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
